import { render, staticRenderFns } from "./EmailSignature.vue?vue&type=template&id=1facddf6&scoped=true&"
import script from "./EmailSignature.vue?vue&type=script&lang=js&"
export * from "./EmailSignature.vue?vue&type=script&lang=js&"
import style0 from "./EmailSignature.vue?vue&type=style&index=0&id=1facddf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1facddf6",
  null
  
)

export default component.exports